import { Fragment } from "react";
import { formatWithDecimals } from "utils";
import { buildFeeRows, FeeRow } from "./buildFeeRows";
import { FeeDetailDto } from "interfaces";
import styles from "./feeTooltip.module.css";
import { Flex, Typography } from "antd";

type Props = {
  feeDetail: FeeDetailDto;
  amountRub: number | undefined;
  showRub: boolean;
  showAmountDiscount: boolean;
  totalFee: number;
  totalFeeRub: number | undefined;
  title: string;
  fee: number;
};

const formatPercent = (value: number): string => `${formatWithDecimals(value * 100, 2)} %`;

const formatRub = (value: number | undefined): string =>
  value === undefined || value === null ? "" : `${formatWithDecimals(value)} руб.`;

export const FeeBreakdown = ({
  feeDetail,
  amountRub,
  showRub,
  showAmountDiscount,
  totalFee,
  totalFeeRub,
  title,
  fee,
}: Props) => {
  const rows = buildFeeRows({ feeDetail, amountRub, showRub, showAmountDiscount, totalFee, totalFeeRub });
  const showAcquiringNote = rows.some((row) => row.key === "acquiringFee");

  return (
    <Flex vertical gap="16px">
      <Flex vertical gap="4px">
        <Typography.Text className={styles.title} strong>
          {title}
        </Typography.Text>
        {/* <Typography.Text className={styles.feeTitle}>{formatWithDecimals(fee * 100, 2)} %</Typography.Text> */}
      </Flex>
      <div className={styles.table}>
        {rows.map((row: FeeRow, index) => {
          const isTotal = !!row.isTotal;
          const showDivider = isTotal && index > 0;
          return (
            <Fragment key={row.key}>
              {showDivider && <hr className={styles.divider} />}
              <span className={`${styles.label} ${isTotal ? styles.totalLabel : ""}`}>{row.label}:</span>
              <span className={`${styles.rub} ${isTotal ? styles.totalRub : ""}`}>
                {showRub ? formatRub(row.rub) : ""}
              </span>
              <span className={`${styles.percent} ${isTotal ? styles.totalPercent : ""}`}>
                {formatPercent(row.percent)}
              </span>
            </Fragment>
          );
        })}
      </div>
      {showAcquiringNote && (
        <Typography.Text className={styles.note}>
          * Комиссия за эквайринг считается по индикативному курсу
        </Typography.Text>
      )}
    </Flex>
  );
};
